import { POST } from "../APiHelper/API"


export const getConversationForPlayerSelection = (fixture_id, selection_id, onSuccess, onError) => {
    const data = {
        fixture_id: fixture_id,
        selection_id: selection_id
    }
    POST("/api/v1/conversations/conversation_for_selection", data, onSuccess, onError)
}